import offlineProgressSync from '../src/react/helpers/OfflineProgressSync';

export const CONNECTIVITY_CHANGE = "connectivity:change";

export function seemsOffline() {
  if (!navigator.onLine) return true;
  if (offlineProgressSync.isOnline === false) return true;
  try {
    if (sessionStorage.getItem("aquifer-online") === "0") return true;
  } catch (_error) {
  }
  return false;
}

export function visit(url) {
  window.__aquiferVisiting = url;
  window.location.assign(url);
}

export function redirectToOfflinePage(returnTo = location.pathname + location.search) {
  visit(`/offline.html?return_to=${encodeURIComponent(returnTo)}`);
}

export async function hasInternetAccess(timeoutMs = 1500) {
  if (!navigator.onLine) return false;

  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  try {
    await fetch("/service-worker.js?ping=1", {
      method: "HEAD",
      cache: "no-store",
      signal: controller.signal,
    });
    return true;
  } catch (err) {
    return err.name === "AbortError";
  } finally {
    clearTimeout(timer);
  }
}
